import { ApiFieldTable } from "./ApiFieldTable.js";

/**
 * Every model in the schema, one block each, so a nested type named in a fields table
 * (for example DatasetAccessMethod[]) can be followed to its own fields.
 */
export function ApiTypesSection({ types, typeNames }) {
  return (
    <section className="apiResource" id="types" aria-labelledby="apiTypesTitle">
      <div className="apiResourceHeader">
        <span className="apiEyebrow">Reference</span>
        <h2 className="apiResourceTitle" id="apiTypesTitle">Data types</h2>
        <p className="apiBody">
          The objects that appear inside responses. Field types that name another object link to it here.
        </p>
      </div>
      {types.map((t) => (
        <div className="apiTableBlock" key={t.name}>
          <h3 className="apiSubhead apiTypeTitle" id={`type-${t.name}`}>{t.name}</h3>
          <ApiFieldTable fields={t.fields} typeNames={typeNames} />
        </div>
      ))}
    </section>
  );
}
